import Vue from 'vue';
import store from './../../store';
import supplierTransformer from './../../transformers/supplier';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const suppliers = supplierTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);

  store.dispatch('fetchPaginatedSuppliers', { suppliers, pagination });
  resolve({ suppliers, pagination });
};

const failed = (error, reject) => reject(error);


export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/suppliers', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/supplier/items.js